import {calculatePrice} from "./template.js"

let gidsTables = [0, 808740199]

createPriceTable(gidsTables, 0)

async function createPriceTable(gidsTables, priceType) {
  const arrayResponse = gidsTables.map((gid) => {
    const url = `https://docs.google.com/spreadsheets/d/1XmA99r-qX_y4lHN34ei-0mztLPFpFWiA0ZWrzRmtiD4/gviz/tq?gid=${gid}`
    //const url = `https://docs.google.com/spreadsheets/d/1w6BC44AbknDEcs9ragbuNBMrTidjqau2pMqVQCAbKQA/gviz/tq?gid=438231591`
    //const url = `https://docs.google.com/spreadsheets/d/1TAnwJlz8lhca0DTtOGH-X3a3Mm_gbcgs55_0SJabdQY/gviz/tq?gid=0`
    return fetch(url)
  })

  const promiseResult = await Promise.all(arrayResponse)

  promiseResult.forEach(
    async (response) => {
      const result = await response.text()
      const parsedJson = JSON.parse(result.substring(47).slice(0, -2))
      const jsonTable = parsedJson.table

      if(jsonTable.cols[0].label == "ID"){
        const fencePrice = []

        for (let i = 0; i < jsonTable.rows.length; i++) {
          const obj = {}
          for (let j = 0; j < jsonTable.cols.length; j++) {
            obj[jsonTable.cols[j].label] = jsonTable.rows[i].c[j].v
          }
          fencePrice.push(obj)
        }

        window.fencePrice = fencePrice

        //console.log(fencePrice)

      }else{
        const obj = {}
        let arrColor = []
        const collections = []

        for (let i = 1; i < jsonTable.rows.length; i++) {
          const value = jsonTable.rows[i].c
          let value1 = null
          let value2 = null
          let value3 = null
          let value4 = null
          let value5 = null
          let value6 = null
          if(i < jsonTable.rows.length && jsonTable.rows[i+1]) value1 = jsonTable.rows[i+1].c
          if(i < jsonTable.rows.length && jsonTable.rows[i+2]) value2 = jsonTable.rows[i+2].c
          if(i < jsonTable.rows.length && jsonTable.rows[i+3]) value3 = jsonTable.rows[i+3].c
          if(i < jsonTable.rows.length && jsonTable.rows[i+4]) value4 = jsonTable.rows[i+4].c
          if(i < jsonTable.rows.length && jsonTable.rows[i+5]) value5 = jsonTable.rows[i+5].c
          if(i < jsonTable.rows.length && jsonTable.rows[i+6]) value6 = jsonTable.rows[i+6].c

          let currectCollection = null

          //console.log({value, value1})

          
          let k = null

          for (let j = 0; j < value.length; j++) {

              // if(!value[j] && i == 1 && currectCollection){
              //     obj[currectCollection] += "__" + value1[j].v
              // }
              
              if(value[j] && value[j].v && i == 1){
                  currectCollection = value[j].v
                  collections.push(currectCollection)
                  const key = value1[j].v
                  if(!obj[currectCollection]) obj[currectCollection] = {}
                  obj[currectCollection][key] = {}
              }
              if(i == 1){
                if(value1[j] && !value[j]){
                  obj[currectCollection][value1[j].v] = {}
                }
              }
              //console.log(currectCollection, value1[j], value2[j], value3[j])
              if(i == 1 && value1[j] && value2[j] && value2[j].v){
                const splited = value2[j].v.split(",")
                splited.map(key => {
                  
                  obj[currectCollection][value1[j].v][key.trim()] = {
                    [value3[0].v]: value3[j] ? value3[j].v : 0,
                    [value4[0].v]: value4[j] ? value4[j].v : 0,
                    [value5[0].v]: value5[j] ? value5[j].v : 0,
                    [value6[0].v]: value6[j] ? value6[j].v : 0,
                  }
                })
                
              }

              if(i == 2 && value[j] && value1[j]){
                //console.log(value5)
              }
              // if(i == 3 || i == 4 || i == 5 || i == 6){
              //   if(value1[j] && value[j] && !k){
              //     k = value1[j].v
              //     obj[k] = []
              //   }
              //   if(value1[j] && value1[j].v && value[j]){
              //     const replaced = value1[j].v.replaceAll(" ", "")
              //     if(replaced && Number(replaced)) obj[k].push(Number(replaced))
              //   }
              
          }
        }

        //console.warn(obj)
        
        function capitalizeFirstLetter(val) {
          return String(val).charAt(0).toUpperCase() + String(val).slice(1);
        }

        // create Price
        const price = {}
        const arrPricesByDepth = []
        const arrDepths = []
        let glI = 0
        // for (let key in obj){
        //   if(typeof obj[key] == "object" && key !== "null"){
        //     arrDepths.push(key)
        //     arrPricesByDepth.push(obj[key])
        //   }
        // }

        // for (let key in obj){
        //   if(typeof obj[key] == "string"){
        //     const splited = obj[key].split("__")
        //     const keyUpperCase = capitalizeFirstLetter(key)
        //     price[keyUpperCase] = {}
        //     splited.map(str => {
        //       str.split(",").map(_ => _.trim()).map(colorName => {
        //         const colorNameUpperCase = capitalizeFirstLetter(colorName)
        //         price[keyUpperCase][colorNameUpperCase] = {}
        //         arrDepths.map((depth, index) => {
        //           price[keyUpperCase][colorNameUpperCase][arrDepths[index]] = arrPricesByDepth[index][glI]
        //         })
        //       })
        //       glI++
        //     })
        //   }
        // }
        //console.log(price)
        window.price = obj
        calculatePrice()
      }

      

    }
  )
}